window.UiIcon = {
  filePath: "/theme/solar/iconset.svg",
  defaultSize: 20,
};

import "kk-web-components";

import "./js/loading-states";

import "./js/swiper";
import "./js/metanav";
import "./js/searchbar";
import "./js/bootstrap-dropdown-to-collapse";
import "./js/bootstrap";
import "./js/header-nav-items-swap-around";
import "./js/lightbox";
import "./js/navbar-onscroll-collapse";
import "./js/performance-weekdays-sticky";
import "./js/table-pagination";
import "./js/move-interscroller";
import "./js/custom-number-input.js";
import "./js/shop.js";
import "./js/form-select-hint.js";
import "./js/pseudo-link.js";
